import produce from 'immer';
import { Action } from '../../redux/types';
import { serviceFactorsPanel } from './PanelServiceFactorsState';

export const serviceFactorsPanelReducer = (state = serviceFactorsPanel, action: Action) => {
  return produce(state, (draft) => {
    return draft;
  });
};
